(function(){
  "use strict";

  window.cmobiPdfLibs = window.cmobiPdfLibs || null;
  window.cmobiPdfLoadPromise = window.cmobiPdfLoadPromise || null;

  function initCmobi(SECTION_ID){
    "use strict";
    const ROOT = document.getElementById('cmobi-' + SECTION_ID);
    if(!ROOT) return;

    const MAX = 4;
    const STORAGE_KEY = 'cmobi_selected_' + SECTION_ID;
    const DIFF_KEY = 'cmobi_diff_' + SECTION_ID;
    const HASH_PREFIX = 'compare=';
    const PLEASURE_ORDER = ['P','L','E','A','S','U','R','3'];
    const ALWAYS_VISIBLE_KEYS = new Set(['name','price','url']);

    let _dataCache = null;
    let _pleasureCache = null;
    let _i18n = null;
    let lastFocusBeforeDialog = null;
    let selected = new Set();

    function parseJSONById(id, fallback){
      try{
        const el = document.getElementById(id);
        if(!el) return fallback;
        let raw = (el.textContent || '').trim().replace(/^\uFEFF/, '');
        return raw ? JSON.parse(raw) : fallback;
      }catch(e){ return fallback; }
    }

    function getI18n(){
      if(!_i18n) _i18n = parseJSONById('cmobi-i18n-' + SECTION_ID, {});
      return _i18n;
    }
    function getData(){
      if(!_dataCache) _dataCache = parseJSONById('cmobi-data-' + SECTION_ID, []);
      return _dataCache;
    }
    function getPleasureMap(){
      if(!_pleasureCache) _pleasureCache = parseJSONById('cmobi-pleasure-' + SECTION_ID, {});
      return _pleasureCache;
    }

    const i18n = getI18n();
    const featureLabels = i18n.features || {};

    function istJa(wert){
      if(wert === true) return true;
      if(typeof wert !== 'string') return false;
      var w = wert.trim().toLowerCase();
      return w === 'ja' || w === 'yes' || w === 'oui' || w === 'si' || w === 'sí';
    }

    function escapeHtml(text){
      if(typeof text !== 'string') return text;
      return text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
    }

    function debounce(fn, ms){
      let t;
      return function(){
        const ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(function(){ fn.apply(ctx, args); }, ms);
      };
    }

    /* D1569: Dieselbe Zahlenerkennung wie parsePriceNumber. Vorher wurde
       jeder Punkt als Tausendertrenner entfernt — „£7,990.00“ auf
       naipo.co.uk wurde so zu 7,99 und die Sortierung nach Preis falsch. */
    function parsePrice(str){
      if(!str || str === '—') return Number.POSITIVE_INFINITY;
      const n = parsePriceNumber(String(str));
      return (n !== null && isFinite(n)) ? n : Number.POSITIVE_INFINITY;
    }

    function saveToStorage(){
      try{ localStorage.setItem(STORAGE_KEY, JSON.stringify([...selected])); }catch(e){}
    }
    function loadFromStorage(){
      try{
        const raw = localStorage.getItem(STORAGE_KEY);
        if(!raw) return;
        const ids = JSON.parse(raw);
        if(!Array.isArray(ids)) return;
        const validIds = new Set(getData().map(m => m.id));
        ids.forEach(id => { if(validIds.has(id) && selected.size < MAX) selected.add(id); });
      }catch(e){}
    }
    function loadFromHash(){
      const hash = window.location.hash;
      if(!hash || hash.indexOf('#' + HASH_PREFIX) !== 0) return false;
      const skus = hash.substring(1 + HASH_PREFIX.length).split(',').map(s => s.trim()).filter(Boolean);
      if(!skus.length) return false;
      const data = getData();
      selected.clear();
      skus.forEach(sku => {
        const m = data.find(x => x.sku === sku);
        if(m && selected.size < MAX) selected.add(m.id);
      });
      return selected.size > 0;
    }
    function saveDiffState(checked){
      try{ localStorage.setItem(DIFF_KEY, checked ? '1' : '0'); }catch(e){}
    }
    function loadDiffState(){
      try{ return localStorage.getItem(DIFF_KEY) === '1'; }catch(e){ return false; }
    }

    function sortList(list, sortBy){
      const products = list.filter(m => !m.is_benchmark);
      const benchmarks = list.filter(m => m.is_benchmark);
      const badges = getPleasureMap();
      const sorted = [...products];
      switch(sortBy){
        case 'pleasur3':
          sorted.sort((a,b) => {
            const aB = badges[a.id];
            const bB = badges[b.id];
            const aIdx = aB ? PLEASURE_ORDER.indexOf(aB) : -1;
            const bIdx = bB ? PLEASURE_ORDER.indexOf(bB) : -1;
            if(aIdx === -1 && bIdx === -1) return a.name.localeCompare(b.name);
            if(aIdx === -1) return 1;
            if(bIdx === -1) return -1;
            if(aIdx === bIdx) return a.name.localeCompare(b.name);
            return aIdx - bIdx;
          });
          break;
        case 'price_asc':
          sorted.sort((a,b) => (parsePrice(a.price) || 0) - (parsePrice(b.price) || 0));
          break;
        case 'price_desc':
          sorted.sort((a,b) => (parsePrice(b.price) || 0) - (parsePrice(a.price) || 0));
          break;
        case 'name_asc':
          sorted.sort((a,b) => a.name.localeCompare(b.name));
          break;
        case 'name_desc':
          sorted.sort((a,b) => b.name.localeCompare(a.name));
          break;
        case 'sku_asc':
          sorted.sort((a,b) => a.sku.localeCompare(b.sku));
          break;
        case 'sku_desc':
          sorted.sort((a,b) => b.sku.localeCompare(a.sku));
          break;
      }
      const catOrder = ['Base','Compact','Pro','Pro Max','Business'];
      benchmarks.sort((a,b) => catOrder.indexOf(a.category) - catOrder.indexOf(b.category));

      const result = [];
      const handledIds = new Set();
      for(const cat of catOrder){
        const bench = benchmarks.find(b => b.category === cat);
        const catProducts = sorted.filter(p => p.category === cat);
        if(bench){ result.push(bench); handledIds.add(bench.id); }
        catProducts.forEach(p => { result.push(p); handledIds.add(p.id); });
      }
      const rest = [...sorted, ...benchmarks].filter(m => !handledIds.has(m.id));
      return [...result, ...rest];
    }

    function favHeartSvg(){
      return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    }
    function renderFavBtn(m){
      const isFav = favorites.has(m.id);
      const lbl = isFav ? (i18n.fav_remove || 'Aus Favoriten entfernen') : (i18n.fav_add || 'Zu Favoriten hinzufügen');
      return `<button type="button" class="cmobi-fav-btn${isFav ? ' cmobi-fav-btn--active' : ''}" data-id="${escapeHtml(m.id)}" aria-pressed="${isFav ? 'true' : 'false'}" aria-label="${escapeHtml(lbl)}" title="${escapeHtml(lbl)}">${favHeartSvg()}</button>`;
    }
    function renderImgCell(m){
      if(m.image){
        return `<div class="cmobi-thumb"><img src="${escapeHtml(m.image)}" alt="${escapeHtml(m.name)}" loading="lazy" width="80" height="80"></div>`;
      }
      return `<div class="cmobi-thumb cmobi-thumb--placeholder" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
      </div>`;
    }
    function stripHtml(s){
      if(!s || typeof s !== 'string') return '';
      return s.replace(/<[^>]*>/g, '').trim();
    }
    function parsePriceNumber(priceStr){
      if(!priceStr || typeof priceStr !== 'string') return null;
      const stripped = stripHtml(priceStr);
      const cleaned = stripped.replace(/[^\d.,]/g, '');
      if(!cleaned) return null;
      const lastDot = cleaned.lastIndexOf('.');
      const lastComma = cleaned.lastIndexOf(',');
      let normalized;
      if(lastComma > lastDot){
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else if(lastDot > lastComma){
        normalized = cleaned.replace(/,/g, '');
      } else {
        normalized = cleaned.replace(',', '.');
      }
      const n = parseFloat(normalized);
      return isNaN(n) ? null : n;
    }

    /* D1569 (Dauerregel David 03.11.2026: andere Währung, anderer Betrag):
       Die Preise kommen aus Shopify schon in der Besucherwährung
       („£7,990.00“ auf naipo.co.uk). Formatiert wurde danach aber fest
       als „7.990,00 €“. Jetzt Währung und Zahlenformat vom Markt; auf
       rhinoshopield.com bleibt die Ausgabe zeichengleich („2.124,15 €“). */
    const NC_WAEHRUNG = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const NC_FORMAT = (function(){
      const l = document.documentElement.lang || 'de';
      if(l.indexOf('-') > 0) return l;
      return l + '-' + ((window.Shopify && Shopify.country) || 'DE');
    })();
    function geldFormat(num, stellen){
      try {
        return num.toLocaleString(NC_FORMAT, {style:'currency', currency:NC_WAEHRUNG, minimumFractionDigits:stellen, maximumFractionDigits:stellen});
      } catch(e) {
        return num.toLocaleString('de-DE', {minimumFractionDigits:stellen, maximumFractionDigits:stellen}) + ' ' + NC_WAEHRUNG;
      }
    }
    function formatPriceDE(num){
      return geldFormat(Math.floor(num), 0);
    }

    function formatPriceFull(num){
      return geldFormat(num, 2);
    }

    function cleanPriceString(priceStr){
      if(!priceStr) return '—';
      const stripped = stripHtml(priceStr);
      if(/~/.test(stripped) || /\d[\s.]*[–\-][\s.]*\d/.test(stripped)){
        return stripped;
      }
      const num = parsePriceNumber(stripped);
      if(num === null) return stripped; // fallback zum gestrippten Original
      return formatPriceFull(num);
    }

    function renderPriceCell(m, opts){
      opts = opts || {};
      const compact = opts.compact === true;
      const rawPrice = m.price || '—';
      const cleanPrice = cleanPriceString(rawPrice);
      if(m.is_benchmark || !m.url || m.url === '#beratung' || m.url === '#benchmark'){
        return `<strong class="cmobi-price-new">${escapeHtml(cleanPrice)}</strong>`;
      }
      const newPriceNum = parsePriceNumber(rawPrice);
      if(newPriceNum === null || newPriceNum <= 0){
        return `<strong class="cmobi-price-new">${escapeHtml(cleanPrice)}</strong>`;
      }
      const refurbLabel = i18n.price_refurb_label || 'NAIPO Refurbished';
      return `
        <div class="cmobi-price-wrap${compact ? ' cmobi-price-wrap--compact' : ''}">
          <div class="cmobi-price-main">
            <strong class="cmobi-price-new">${escapeHtml(cleanPrice)}</strong>
          </div>
          <button type="button" class="cmobi-price-refurb cmobi-refurb-trigger" aria-label="${escapeHtml(i18n.price_info_aria || 'Refurbished-Info anzeigen')}">
            ${escapeHtml(refurbLabel)}
            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          </button>
        </div>`;
    }

    function renderTable(list){
      const tbody = document.getElementById('cmobi-body-' + SECTION_ID);
      if(!tbody) return;
      tbody.innerHTML = list.map(m => {
        const checked = selected.has(m.id) ? 'checked' : '';
        const safeName = escapeHtml(m.name);
        const ariaLbl = (i18n.aria_select || 'Zum Vergleich auswählen: {name}').replace('{name}', safeName);
        const isBench = m.is_benchmark === true;
        const urlCell = isBench
          ? '<span class="cmobi-link-btn cmobi-link-btn--disabled">' + (getI18n().richtwert || '') + '</span>'
          : (m.url === '#beratung'
              ? `<a class="cmobi-link-btn" href="#beratung">${escapeHtml(i18n.cta_consult || 'Beratung')}</a>`
              : `<a class="cmobi-link-btn cmobi-buy-trigger" href="${escapeHtml(m.url)}" data-product-id="${escapeHtml(m.id)}" rel="noopener">${escapeHtml(i18n.cta_product || 'Zum Produkt')} ➔</a>`);
        return `<tr data-id="${escapeHtml(m.id)}"${isBench ? ' class="cmobi-body-row-benchmark"' : ''}>
          <td>
            <div class="cmobi-prod-cell">
              ${renderImgCell(m)}
              <div class="cmobi-prod-info">
                <span class="cmobi-name">${safeName}</span>
                ${renderBadges(m.badges)}
                <span class="cmobi-sub">${escapeHtml(i18n.lbl_sku || 'SKU')}: ${escapeHtml(m.sku)}</span>
              </div>
              ${isBench ? '' : renderFavBtn(m)}
            </div>
          </td>
          <td><span class="cmobi-cat-tag">${escapeHtml(m.category)}</span></td>
          <td>${urlCell}</td>
          <td>${escapeHtml(m.sku)}</td>
          <td>${renderPriceCell(m)}</td>
          <td class="cmobi-hl">${escapeHtml(m.tech || '')} · ${escapeHtml(m.track || '')}</td>
          <td><input type="checkbox" class="cmobi-chk" data-id="${escapeHtml(m.id)}" aria-label="${ariaLbl}" ${checked}></td>
        </tr>`;
      }).join('');
    }

    function renderCards(list){
      const wrap = document.getElementById('cmobi-cards-' + SECTION_ID);
      if(!wrap) return;
      wrap.innerHTML = list.map(m => {
        const checked = selected.has(m.id) ? 'checked' : '';
        const safeName = escapeHtml(m.name);
        const ariaLbl = (i18n.aria_select || 'Zum Vergleich auswählen: {name}').replace('{name}', safeName);
        const isBench = m.is_benchmark === true;
        const primaryBtn = isBench
          ? '<span class="cmobi-btn cmobi-btn-primary sm" style="opacity:.5;cursor:default;" aria-disabled="true">' + (getI18n().richtwert || '') + '</span>'
          : (m.url === '#beratung'
              ? `<a class="cmobi-btn cmobi-btn-primary sm" href="#beratung" rel="noopener">${escapeHtml(i18n.cta_consult || 'Beratung')} ➔</a>`
              : `<a class="cmobi-btn cmobi-btn-primary sm cmobi-buy-trigger" href="${escapeHtml(m.url)}" data-product-id="${escapeHtml(m.id)}" rel="noopener">${escapeHtml(i18n.cta_product || 'Zum Produkt')} ➔</a>`);
        return `<article class="cmobi-card${isBench ? ' cmobi-card--benchmark' : ''}" data-id="${escapeHtml(m.id)}">
          <div class="cmobi-card-img-wrap">
            ${m.image ? `<img class="cmobi-card-img" src="${escapeHtml(m.image)}" alt="${safeName}" loading="lazy">` : '<div class="cmobi-card-img-placeholder"></div>'}
            ${isBench ? '' : renderFavBtn(m)}
            ${renderBadges(m.badges)}
          </div>
          <header class="cmobi-card-head">
            <span class="cmobi-card-title">${safeName}</span>
            <span class="cmobi-cat-tag">${escapeHtml(m.category)}</span>
          </header>
          <div class="cmobi-card-body">
            <div class="cmobi-card-row"><strong>${escapeHtml(i18n.lbl_sku || 'SKU')}:</strong> ${escapeHtml(m.sku)}</div>
            <div class="cmobi-card-row"><strong>${escapeHtml(i18n.lbl_price || 'Preis')}:</strong> ${renderPriceCell(m, {compact:true})}</div>
            <div class="cmobi-card-row cmobi-hl">${escapeHtml(m.tech || '')} · ${escapeHtml(m.track || '')}</div>
          </div>
          <footer class="cmobi-card-foot">
            ${primaryBtn}
            <label class="cmobi-card-chk"><input type="checkbox" class="cmobi-chk" data-id="${escapeHtml(m.id)}" aria-label="${ariaLbl}" ${checked}><span>${escapeHtml(i18n.compare_btn || 'Vergleichen')}</span></label>
          </footer>
        </article>`;
      }).join('');
    }

    function renderEmpty(show){
      const empty = document.getElementById('cmobi-empty-' + SECTION_ID);
      const tableWrap = ROOT.querySelector('.cmobi-table-wrap');
      const cardsWrap = document.getElementById('cmobi-cards-' + SECTION_ID);
      if(empty) empty.hidden = !show;
      if(tableWrap) tableWrap.style.display = show ? 'none' : '';
      if(cardsWrap) cardsWrap.style.display = show ? 'none' : '';
    }

    function renderCount(total, filtered){
      const el = document.getElementById('cmobi-count-' + SECTION_ID);
      if(!el) return;
      const tpl = filtered === total
        ? (i18n.count_total || '{count} Produkte')
        : (i18n.count_filtered || '{filtered} von {total} Produkten');
      el.textContent = tpl.replace('{count}', total).replace('{filtered}', filtered).replace('{total}', total);
    }

    function getFiltered(){
      const data = getData();
      const q = (document.getElementById('cmobi-q-' + SECTION_ID)?.value || '').toLowerCase();
      const sortBy = document.getElementById('cmobi-sort-' + SECTION_ID)?.value || 'pleasur3';
      let filtered = data.filter(m => {
        if(q && !(m.name.toLowerCase().includes(q) || m.sku.toLowerCase().includes(q))) return false;
        return true;
      });
      filtered = applyChipFilters(filtered);
      return { all: data, list: sortList(filtered, sortBy) };
    }

    function refresh(){
      const { all, list } = getFiltered();
      renderEmpty(list.length === 0);
      renderTable(list);
      renderCards(list);
      renderCount(all.length, list.length);
      updateBar();
      updateChipCounts(); // v6.3: Filter-Counts auf Chips
    }

    function updateChipCounts(){
      const data = getData().filter(m => !m.is_benchmark);
      const qEl = document.getElementById('cmobi-q-' + SECTION_ID);
      const q = qEl ? qEl.value.trim().toLowerCase() : '';
      const baseList = q
        ? data.filter(m => m.name.toLowerCase().includes(q) || m.sku.toLowerCase().includes(q))
        : data;

      function countWithOverride(overrides){
        return baseList.filter(m => {
          const cat = overrides.category !== undefined ? overrides.category : CHIP_STATE.category;
          if(cat && m.category !== cat) return false;
          const price = overrides.price !== undefined ? overrides.price : CHIP_STATE.price;
          if(price){
            const [lo, hi] = price.split('-').map(Number);
            const p = parsePrice(m.price);
            if(p === null) return false;
            if(p < lo || p > hi) return false;
          }
          const feats = overrides.feats !== undefined ? overrides.feats : CHIP_STATE.feats;
          if(feats && feats.size){
            for(const f of feats){
              if(f === 'benchmark' || f === 'favorites') continue;
              const fn = FEATURE_FLAGS[f];
              if(fn && !fn(m)) return false;
            }
          }
          return true;
        }).length;
      }

      ROOT.querySelectorAll('.cmobi-chip[data-filter]').forEach(chip => {
        const filter = chip.dataset.filter;
        const value = chip.dataset.value;
        let count;
        if(filter === 'category'){
          count = countWithOverride({category: value});
        } else if(filter === 'price'){
          count = countWithOverride({price: value});
        } else if(filter === 'feat'){
          if(value === 'benchmark' || value === 'favorites') return;
          const tempFeats = new Set(CHIP_STATE.feats);
          tempFeats.add(value);
          count = countWithOverride({feats: tempFeats});
        } else {
          return;
        }

        const oldBadge = chip.querySelector('.cmobi-chip-count');
        if(oldBadge) oldBadge.remove();

        const isActive = chip.classList.contains('cmobi-chip--active');
        if(count > 0 || isActive){
          const badge = document.createElement('span');
          badge.className = 'cmobi-chip-count';
          badge.textContent = count;
          if(count === 0) badge.classList.add('cmobi-chip-count--zero');
          chip.appendChild(badge);
        }

        if(count === 0 && !isActive){
          chip.classList.add('cmobi-chip--zero');
        } else {
          chip.classList.remove('cmobi-chip--zero');
        }
      });
    }

    function syncCheckboxes(){
      ROOT.querySelectorAll('.cmobi-chk').forEach(cb => {
        cb.checked = selected.has(cb.dataset.id);
      });
    }

    function toggleSelect(id){
      if(selected.has(id)){
        selected.delete(id);
      } else {
        if(selected.size >= MAX){
          alert(i18n.max_alert || 'Maximal ' + MAX + ' Produkte');
          syncCheckboxes(); // revert the checkbox that triggered this
          return;
        }
        selected.add(id);
      }
      saveToStorage();
      syncCheckboxes();
      updateBar();
    }

    function updateBar(){
      const bar = document.getElementById('cmobi-bar-' + SECTION_ID);
      const sel = document.getElementById('cmobi-selected-' + SECTION_ID);
      if(!bar || !sel) return;
      updateSelCount();
      if(selected.size === 0){
        bar.hidden = true;
        ROOT.classList.remove('cmobi--bar-visible');
        return;
      }
      bar.hidden = false;
      ROOT.classList.add('cmobi--bar-visible');
      const data = getData();
      const map = new Map(data.map(m => [m.id, m]));
      sel.innerHTML = [...selected].map(id => {
        const m = map.get(id);
        return m ? `<span class="cmobi-tag" data-id="${escapeHtml(id)}">${escapeHtml(m.name)} <button type="button" class="cmobi-tag-x" aria-label="Entfernen">×</button></span>` : '';
      }).join('');
    }

    function getShareUrl(){
      const skus = [...selected].map(id => {
        const m = getData().find(x => x.id === id);
        return m ? m.sku : null;
      }).filter(Boolean);
      const base = window.location.href.split('#')[0];
      return skus.length ? base + '#' + HASH_PREFIX + skus.join(',') : base;
    }

    function getShareNames(){
      return [...selected].map(id => {
        const m = getData().find(x => x.id === id);
        return m ? m.name : null;
      }).filter(Boolean);
    }

    function getShareText(){
      const namen = getShareNames();
      if(!namen.length) return i18n.share_none || 'Massagesessel im Vergleich bei NAIPO';
      if(namen.length === 1) return (i18n.share_one || '{name} bei NAIPO ansehen').replace('{name}', namen[0]);
      const wOder = i18n.word_or || 'oder';
      const liste = namen.slice(0, -1).join(', ') + ' ' + wOder + ' ' + namen[namen.length - 1];
      return (i18n.share_many || '{names}? Mein Vergleich bei NAIPO').replace('{names}', liste);
    }

    function zeigeAntwortLeiste(){
      if(!/#.*compare=/.test(window.location.hash)) return;
      const leiste = document.getElementById('cmobi-antwort-' + SECTION_ID);
      if(!leiste) return;
      const namen = getShareNames();
      if(namen.length < 1) return;
      const knopfBox = leiste.querySelector('[data-antwort-knoepfe]');
      if(!knopfBox) return;
      knopfBox.innerHTML = namen.map((n, i) =>
        `<button type="button" class="cmobi-btn ghost cmobi-antwort-btn" data-antwort="${escapeHtml(n)}">${escapeHtml(n)}</button>`
      ).join('');
      leiste.hidden = false;
    }

    function antwortSenden(name){
      const url = getShareUrl();
      const text = encodeURIComponent((i18n.wa_pick || '') + name + '\n' + url);
      const mobil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      window.open((mobil ? 'whatsapp://send?text=' : 'https://wa.me/?text=') + text, '_blank', 'noopener');
    }

    function shareNative(){
      const url = getShareUrl();
      if(navigator.share){
        navigator.share({
          title: i18n.share_title || 'NAIPO Massagesessel Vergleich',
          text: getShareText(),
          url: url
        }).catch(() => {});
      } else {
        copyShareLink();
      }
    }

    function shareWhatsApp(){
      const url = getShareUrl();
      const text = encodeURIComponent(getShareText() + ':\n' + url);
      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      const href = isMobile
        ? 'whatsapp://send?text=' + text
        : 'https://wa.me/?text=' + text;
      window.open(href, '_blank', 'noopener');
    }

    function copyShareLink(){
      const url = getShareUrl();
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(url).then(showToast).catch(() => fallbackCopy(url));
      } else {
        fallbackCopy(url);
      }
    }

    function fallbackCopy(text){
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.cssText = 'position:fixed;left:-9999px';
      document.body.appendChild(ta);
      ta.select();
      try{ document.execCommand('copy'); showToast(); }catch(e){ alert(i18n.share_error || 'Kopieren fehlgeschlagen'); }
      document.body.removeChild(ta);
    }

    function showToast(){
      const compareDlg = document.getElementById('cmobi-dialog-' + SECTION_ID);
      const inDialog = compareDlg && compareDlg.open;
      const id = inDialog ? 'cmobi-toast-dialog-' + SECTION_ID : 'cmobi-toast-' + SECTION_ID;
      const toast = document.getElementById(id);
      if(!toast) return;
      toast.classList.add('show');
      clearTimeout(toast._timer);
      toast._timer = setTimeout(() => { toast.classList.remove('show'); }, 3000);
    }

    const FEATURE_GROUPS = [
      { key: 'kopf',    keys: ['name','price','url'] },
      { key: 'passform', keys: ['height_range','max_weight','max_foot_size','shoulder_width_inside','seat_width_inside'] },
      { key: 'raum',    keys: ['dimensions_upright','dimensions_recline','forward_sliding','net_weight','packing_size','assembly_needed','gross_weight'] },
      { key: 'massage', keys: ['massage_area','massage_intensity','tech','track','track_len','zero_g','foot_rollers',
                               'calf_extension_type','calf_extension_distance','air_pressure_massage',
                               'pneumatic_airbag_count','pneumatic_parts','pneumatic_strength','heating_areas'] },
      { key: 'programme', keys: ['programs_auto','programs_manual','programs_manual_parts','programs_manual_tech',
                                 'programs_manual_strength','programs_manual_speed','programs_manual_range',
                                 'health_detection','fatigue_detection','memory_function','reset_function'] },
      { key: 'bedienung', keys: ['operation_methods','voice_control','controller_storage','mobile_phone_stand',
                                 'bluetooth_feature','lights','aroma','phone_charging'] },
      { key: 'technik',  keys: ['leather_materials','power','rated_voltage','anti_pinch_system','special_function'] }
    ];
    const FEATURE_KEYS = FEATURE_GROUPS.reduce((a, g) => a.concat(g.keys), []);

    function openCompare(triggerEl){
      if(selected.size < 2){
        alert(i18n.min2_alert || i18n.min_alert || '');
        return;
      }
      lastFocusBeforeDialog = triggerEl || document.activeElement;
      const dialog = document.getElementById('cmobi-dialog-' + SECTION_ID);
      const wrap = document.getElementById('cmobi-compare-wrap-' + SECTION_ID);
      const allData = getData();
      const baseItems = [...selected].map(id => allData.find(m => m.id === id)).filter(Boolean);

      const userCategories = new Set();
      baseItems.forEach(m => { if(!m.is_benchmark && m.category) userCategories.add(m.category); });
      const matchingBenchmarks = [];
      const userPickedBenchIds = new Set(baseItems.filter(m => m.is_benchmark).map(m => m.id));
      userCategories.forEach(cat => {
        const bench = allData.find(m => m.is_benchmark && m.category === cat);
        if(bench && !userPickedBenchIds.has(bench.id) && !baseItems.includes(bench)){
          matchingBenchmarks.push(bench);
        }
      });
      const items = [...baseItems, ...matchingBenchmarks];

      const diffKeys = new Set();
      FEATURE_KEYS.forEach(key => {
        const vals = items.map(m => (m[key] || '—').toString().trim());
        if(new Set(vals).size > 1) diffKeys.add(key);
      });

      wrap.innerHTML = `
      <div class="cmobi-compare-hint" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12 3 12"/><polyline points="19 12 21 12"/><line x1="5" y1="12" x2="19" y2="12"/><polyline points="9 8 5 12 9 16"/><polyline points="15 8 19 12 15 16"/></svg>
        <span>${i18n.scroll_hint || ''}</span>
      </div>
      <div class="cmobi-compare-grid" style="--cols:${items.length + 1}">
        ${FEATURE_GROUPS.map(grp => {
          const gruppenTitel = (i18n.groups || {})[grp.key];
          const kopf = (grp.key === 'kopf' || !gruppenTitel) ? '' :
            `<div class="cmobi-kv-group" style="--cols:${items.length + 1}"><div class="cmobi-kv-group-label">${escapeHtml(gruppenTitel)}</div></div>`;
          return kopf + grp.keys.map(key => {
          const label = featureLabels[key] || key;
          const hint = (i18n.hints || {})[key];
          const isDiff = diffKeys.has(key);
          const alwaysVisible = ALWAYS_VISIBLE_KEYS.has(key);
          return `<div class="cmobi-kv-row${isDiff ? ' cmobi-kv-diff' : ''}${alwaysVisible ? ' cmobi-kv-always' : ''}" data-key="${escapeHtml(key)}">
            <div class="cmobi-kv-label">${escapeHtml(label)}${hint ? `<span class="cmobi-kv-hint">${escapeHtml(hint)}</span>` : ''}</div>
            ${items.map(m => {
              const isBench = m.is_benchmark === true;
              let val = m[key] || '—';
              if(key === 'url' && val !== '—' && val !== '#beratung' && val !== '#benchmark'){
                val = `<a class="cmobi-link-btn cmobi-buy-trigger" href="${escapeHtml(val)}" data-product-id="${escapeHtml(m.id)}" rel="noopener">${escapeHtml(i18n.cta_product || 'Zum Produkt')} ➔</a>`;
              } else if(val === '#beratung'){
                val = `<a class="cmobi-link-btn" href="#beratung">${escapeHtml(i18n.cta_consult || 'Beratung')}</a>`;
              } else if(val === '#benchmark'){
                val = '<span class="cmobi-link-btn cmobi-link-btn--disabled">' + (getI18n().richtwert || '') + '</span>';
              } else if(key === 'price'){
                val = escapeHtml(cleanPriceString(val));
              } else {
                val = escapeHtml(val);
              }
              return `<div class="cmobi-kv-val${isBench ? ' cmobi-kv-bench' : ''}">${val}</div>`;
            }).join('')}
          </div>`;
          }).join('');
        }).join('')}
      </div>
      ${diffKeys.size === 0 ? `<p class="cmobi-diff-none">${i18n.diff_same || 'Alle Werte sind identisch.'}</p>` : ''}
      ${items.some(m => m.is_benchmark) ? `<p class="cmobi-bench-disclaimer"><strong style="color:#ff9800;">Markt-Durchschnitt (Ø)-Spalten:</strong> Aggregierte Daten der letzten 30 Tage aus Google Shopping &amp; öffentlich einsehbaren Anbieter-Webseiten. Werte sind Schätzungen typischer Konkurrenz-Angebote im jeweiligen Preissegment — keine Einzel-Produkte.</p>` : ''}`;

      dialog.showModal();

      const diffToggle = document.getElementById('cmobi-diff-' + SECTION_ID);
      if(diffToggle){
        diffToggle.checked = loadDiffState();
        toggleDiffHighlight(diffToggle.checked);
      }

      const firstFocusable = dialog.querySelector('button, a, input');
      if(firstFocusable){
        try{ firstFocusable.focus(); }catch(e){}
      }
    }

    function closeCompare(){
      const dialog = document.getElementById('cmobi-dialog-' + SECTION_ID);
      if(dialog) dialog.close();
    }

    function cmobiTriggerNabe(productIds){
      try{
        const cmpDlg = document.getElementById('cmobi-dialog-' + SECTION_ID);
        if(cmpDlg && cmpDlg.open) cmpDlg.close();
        const buyDlg = document.getElementById('cmobi-buy-dialog-' + SECTION_ID);
        if(buyDlg && buyDlg.open) buyDlg.close();
      }catch(e){}
      if(productIds && productIds.length){
        try{
          const data = getData();
          const names = productIds
            .map(id => { const m = data.find(x => x.id === id); return m ? m.name : null; })
            .filter(Boolean);
          if(names.length){
            sessionStorage.setItem('cmobi_nabe_context', JSON.stringify({products: names, ts: Date.now()}));
          }
        }catch(e){}
      }
      const isMobile = window.innerWidth <= 640;
      setTimeout(() => {
        if(isMobile){
          const trig = document.getElementById('nabe-mini-trigger-' + SECTION_ID);
          if(trig){ try{ trig.click(); return; }catch(e){} }
        }
        const nabe = document.querySelector('.nabe[data-nabe-id="' + SECTION_ID + '"]');
        if(nabe){
          try{ nabe.scrollIntoView({behavior:'smooth', block:'center'}); }catch(e){ nabe.scrollIntoView(); }
          nabe.classList.add('nabe-pulse');
          setTimeout(() => { nabe.classList.remove('nabe-pulse'); }, 2200);
        }
      }, 180);
    }

    function toggleDiffHighlight(showOnlyDiff){
      const wrap = document.getElementById('cmobi-compare-wrap-' + SECTION_ID);
      if(!wrap) return;
      const rows = wrap.querySelectorAll('.cmobi-kv-row');
      rows.forEach(row => {
        if(showOnlyDiff){
          if(row.classList.contains('cmobi-kv-diff') || row.classList.contains('cmobi-kv-always')){
            row.style.display = '';
          } else {
            row.style.display = 'none';
          }
        } else {
          row.style.display = '';
        }
      });
    }

    function injectJsonLd(){
      try{
        const marker = 'data-cmobi-schema-' + SECTION_ID;
        if(document.querySelector('script[' + marker + ']')) return;
        const data = getData();
        const origin = window.location.origin;
        const absUrl = u => (u && u.indexOf('http') === 0) ? u : origin + (u || '');
        const productLd = data
          .filter(m => m.url && m.url !== '#beratung' && m.url !== '#benchmark' && !m.is_benchmark)
          .map(m => {
            const priceNum = parsePrice(m.price);
            const obj = {
              "@context": "https://schema.org/",
              "@type": "Product",
              "name": m.name,
              "sku": m.sku,
              "mpn": m.sku,
              "category": m.category,
              "brand": { "@type": "Brand", "name": (m.badges && m.badges.indexOf('aspria') >= 0) ? "Aspria by NAIPO" : "NAIPO" },
              "url": absUrl(m.url)
            };
            if(m.image) obj.image = m.image;
            if(m.massage_area && m.massage_area !== '—') obj.description = 'Massage-Bereich: ' + m.massage_area + '. Technologie: ' + (m.tech || '—') + '. Schiene: ' + (m.track || '—') + '.';
            if(priceNum !== null){
              const avail = (m.badges && m.badges.indexOf('discontinued') >= 0)
                ? "https://schema.org/Discontinued"
                : "https://schema.org/InStock";
              obj.offers = {
                "@type": "Offer",
                "priceCurrency": "EUR",
                "price": priceNum.toFixed(2),
                "availability": avail,
                "url": absUrl(m.url),
                "seller": { "@type": "Organization", "name": "Alsterwell GmbH" }
              };
            }
            return obj;
          });
        const realProducts = data.filter(m => !m.is_benchmark);
        const itemList = {
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": getI18n().share_title || 'NAIPO Massagesessel Vergleich',
          "numberOfItems": realProducts.length,
          "itemListElement": realProducts.map((m, i) => ({
            "@type": "ListItem",
            "position": i + 1,
            "url": absUrl(m.url === '#beratung' ? '/pages/kontakt' : m.url),
            "name": m.name
          }))
        };
        [itemList, ...productLd].forEach(ld => {
          const s = document.createElement('script');
          s.type = 'application/ld+json';
          s.setAttribute('data-cmobi-schema-' + SECTION_ID, '1');
          s.textContent = JSON.stringify(ld);
          document.head.appendChild(s);
        });
      }catch(e){}
    }

    const THEME_KEY = 'cmobi_theme';
    function initTheme(){
      let stored = null;
      try{ stored = localStorage.getItem(THEME_KEY); }catch(e){}
      if(stored === 'dark' || stored === 'light'){
        ROOT.setAttribute('data-theme', stored);
      }
      updateThemeIcon();
    }
    function getEffectiveTheme(){
      const explicit = ROOT.getAttribute('data-theme');
      if(explicit) return explicit;
      return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    function toggleTheme(){
      const next = getEffectiveTheme() === 'dark' ? 'light' : 'dark';
      ROOT.setAttribute('data-theme', next);
      try{ localStorage.setItem(THEME_KEY, next); }catch(e){}
      updateThemeIcon();
    }
    function updateThemeIcon(){
      const btn = document.getElementById('cmobi-theme-' + SECTION_ID);
      if(!btn) return;
      const isDark = getEffectiveTheme() === 'dark';
      btn.classList.toggle('cmobi-theme-is-dark', isDark);
    }

    const CHIP_STATE = { category: '', price: '', feats: new Set() };
    const FEATURE_FLAGS = {
      zero_g:   m => /Ja/i.test(m.zero_g || ''),
      '4d':     m => /4D/i.test(m.tech || ''),
      aroma:    m => /Ja/i.test(m.aroma || ''),
      heating:  m => m.heating_areas && m.heating_areas !== '—' && m.heating_areas.length > 2,
      compact:  m => m.category === 'Compact',
      favorites:m => favorites.has(m.id)
    };
    function applyChipFilters(list){
      const showBenchmarks = CHIP_STATE.feats.has('benchmark');
      return list.filter(m => {
        if(m.is_benchmark && !showBenchmarks) return false;
        if(CHIP_STATE.category && m.category !== CHIP_STATE.category) return false;
        if(CHIP_STATE.price){
          const [lo, hi] = CHIP_STATE.price.split('-').map(Number);
          const p = parsePrice(m.price);
          if(p === null) return false;
          if(p < lo || p > hi) return false;
        }
        if(CHIP_STATE.feats.size){
          for(const f of CHIP_STATE.feats){
            if(f === 'benchmark') continue; // dieser Chip ist Sichtbarkeits-Toggle, kein Filter
            const fn = FEATURE_FLAGS[f];
            if(fn && !fn(m)) return false;
          }
        }
        return true;
      });
    }
    function toggleChip(filter, value, btn){
      if(filter === 'category' || filter === 'price'){
        CHIP_STATE[filter] = value;
        btn.parentElement.querySelectorAll('.cmobi-chip[data-filter="' + filter + '"]').forEach(b => b.classList.remove('cmobi-chip--active'));
        btn.classList.add('cmobi-chip--active');
      } else if(filter === 'feat'){
        if(CHIP_STATE.feats.has(value)){
          CHIP_STATE.feats.delete(value);
          btn.classList.remove('cmobi-chip--active');
          if(value === 'benchmark'){
            const banner = document.getElementById('cmobi-bench-banner-' + SECTION_ID);
            if(banner) banner.hidden = true;
          }
        } else {
          CHIP_STATE.feats.add(value);
          btn.classList.add('cmobi-chip--active');
          if(value === 'benchmark'){
            const banner = document.getElementById('cmobi-bench-banner-' + SECTION_ID);
            if(banner) banner.hidden = false;
            try{
              setTimeout(() => {
                const benchRow = document.querySelector('.cmobi-body-row-benchmark, .cmobi-card--benchmark');
                if(benchRow){
                  benchRow.scrollIntoView({behavior:'smooth', block:'center'});
                  benchRow.style.transition = 'box-shadow 0.6s ease';
                  benchRow.style.boxShadow = '0 0 0 4px rgba(255,152,0,.5)';
                  setTimeout(() => { benchRow.style.boxShadow = ''; }, 1500);
                }
              }, 200);
            }catch(e){}
          }
        }
      }
      refresh();
    }

    const FAV_KEY = 'cmobi_favorites_' + SECTION_ID;
    let favorites = new Set();
    function loadFavorites(){
      try{
        const raw = localStorage.getItem(FAV_KEY);
        if(raw){ favorites = new Set(JSON.parse(raw)); }
      }catch(e){ favorites = new Set(); }
      updateFavCount();
    }
    function saveFavorites(){
      try{ localStorage.setItem(FAV_KEY, JSON.stringify([...favorites])); }catch(e){}
    }
    function toggleFavorite(id){
      if(favorites.has(id)) favorites.delete(id); else favorites.add(id);
      saveFavorites();
      updateFavCount();
      if(CHIP_STATE.feats.has('favorites')){
        refresh();
      } else {
        syncFavoriteHearts();
      }
    }
    function syncFavoriteHearts(){
      ROOT.querySelectorAll('.cmobi-fav-btn').forEach(btn => {
        const id = btn.dataset.id;
        const isFav = favorites.has(id);
        btn.classList.toggle('cmobi-fav-btn--active', isFav);
        btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');
        btn.setAttribute('aria-label', isFav ? (i18n.fav_remove || 'Aus Favoriten entfernen') : (i18n.fav_add || 'Zu Favoriten hinzufügen'));
      });
    }
    function updateFavCount(){
      const el = document.getElementById('cmobi-fav-count-' + SECTION_ID);
      if(el) el.textContent = favorites.size;
      const chip = document.getElementById('cmobi-chip-fav-' + SECTION_ID);
      if(chip){
        chip.classList.toggle('cmobi-chip--has-items', favorites.size > 0);
      }
    }

    function renderBadges(badges){
      if(!Array.isArray(badges) || !badges.length) return '';
      const labels = i18n.badges || {};
      return '<div class="cmobi-badges">' + badges.map(b => {
        const label = labels[b] || b;
        return `<span class="cmobi-badge cmobi-badge--${escapeHtml(b)}">${escapeHtml(label)}</span>`;
      }).join('') + '</div>';
    }

    function updateSelCount(){
      const el = document.getElementById('cmobi-sel-count-' + SECTION_ID);
      if(el){
        const tpl = i18n.sel_count || '{n} von 4 ausgewählt';
        el.textContent = tpl.replace('{n}', selected.size);
      }
      const countEl = document.getElementById('cmobi-open-count-' + SECTION_ID);
      if(countEl){
        countEl.textContent = selected.size + '/' + MAX;
      }
      const bar = document.getElementById('cmobi-bar-' + SECTION_ID);
      if(bar){
        bar.classList.toggle('cmobi-bar--max', selected.size >= MAX);
      }
    }

    const QUIZ_QUESTIONS = [
      { id: 'q1', options: [
        { key: 'a1', score: { budget: 1500 } },
        { key: 'a2', score: { budget: 3000 } },
        { key: 'a3', score: { budget: 5000 } },
        { key: 'a4', score: { budget: 8000 } }
      ]},
      { id: 'q2', options: [
        { key: 'a1', score: { space: 'compact' } },
        { key: 'a2', score: { space: 'medium' } },
        { key: 'a3', score: { space: 'large' } }
      ]},
      { id: 'q3', options: [
        { key: 'a1', score: { tech: 'basic' } },
        { key: 'a2', score: { tech: '3d' } },
        { key: 'a3', score: { tech: '4d' } }
      ]},
      { id: 'q4', options: [
        { key: 'a1', score: { use: 'wellness' } },
        { key: 'a2', score: { use: 'therapy' } },
        { key: 'a3', score: { use: 'b2b' } }
      ]},
      { id: 'q5', options: [
        { key: 'a1', score: { height: 'small' } },
        { key: 'a2', score: { height: 'medium' } },
        { key: 'a3', score: { height: 'tall' } }
      ]}
    ];
    let quizAnswers = [];
    let quizStep = 0;

    function openQuiz(triggerEl){
      lastFocusBeforeDialog = triggerEl || document.activeElement;
      quizAnswers = [];
      quizStep = 0;
      const dlg = document.getElementById('cmobi-quiz-dialog-' + SECTION_ID);
      if(!dlg) return;
      renderQuizIntro();
      dlg.showModal();
    }
    function closeQuiz(){
      const dlg = document.getElementById('cmobi-quiz-dialog-' + SECTION_ID);
      if(dlg) dlg.close();
    }

    function openBuyDialog(productId, triggerEl){
      const data = getData();
      const product = data.find(m => m.id === productId);
      if(!product) return;
      lastFocusBeforeDialog = triggerEl || document.activeElement;
      const dlg = document.getElementById('cmobi-buy-dialog-' + SECTION_ID);
      if(!dlg) return;

      const imgWrap = document.getElementById('cmobi-buy-preview-img-' + SECTION_ID);
      if(imgWrap){
        if(product.image){
          imgWrap.innerHTML = `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.name)}" loading="lazy">`;
        } else {
          imgWrap.innerHTML = '<div class="cmobi-buy-preview-placeholder" aria-hidden="true"><svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity="0.5"><rect x="4" y="3" width="16" height="9" rx="2"/><path d="M4 12v6"/><path d="M20 12v6"/><path d="M4 18h16"/><path d="M6 18v3"/><path d="M18 18v3"/></svg></div>';
        }
      }
      const nameEl = document.getElementById('cmobi-buy-preview-name-' + SECTION_ID);
      if(nameEl) nameEl.textContent = product.name;
      const catEl = document.getElementById('cmobi-buy-preview-cat-' + SECTION_ID);
      if(catEl) catEl.textContent = product.category;
      const priceEl = document.getElementById('cmobi-buy-preview-price-' + SECTION_ID);
      if(priceEl) priceEl.textContent = cleanPriceString(product.price);

      const naipoLink = document.getElementById('cmobi-buy-naipo-' + SECTION_ID);
      if(naipoLink) naipoLink.setAttribute('href', product.url);

      const refurbBox = document.getElementById('cmobi-buy-refurb-' + SECTION_ID);
      const refurbRecBadge = document.getElementById('cmobi-buy-refurb-rec-' + SECTION_ID);
      if(refurbBox){
        if(product.refurbished_available){
          refurbBox.hidden = false;
          const cta = refurbBox.querySelector('.cmobi-buy-refurb-cta');
          if(cta && product.refurbished_url){
            cta.setAttribute('href', product.refurbished_url);
          }
          if(refurbRecBadge){
            const isRecommended = Array.isArray(product.badges) && product.badges.indexOf('refurbished_pick') >= 0;
            refurbRecBadge.hidden = !isRecommended;
          }
        } else {
          refurbBox.hidden = true;
        }
      }

      const waBtn = document.getElementById('cmobi-buy-fallback-wa-' + SECTION_ID);
      if(waBtn) waBtn.dataset.productId = product.id;
      const consultBtn = document.getElementById('cmobi-buy-fallback-consult-' + SECTION_ID);
      if(consultBtn) consultBtn.dataset.productId = product.id;

      try{ dlg.showModal(); }catch(e){ dlg.setAttribute('open', ''); }
      setTimeout(() => { try{ naipoLink?.focus(); }catch(e){} }, 50);
    }
    function closeBuyDialog(){
      const dlg = document.getElementById('cmobi-buy-dialog-' + SECTION_ID);
      if(dlg) dlg.close();
    }

    function openRefurbDialog(triggerEl){
      lastFocusBeforeDialog = triggerEl || document.activeElement;
      const dlg = document.getElementById('cmobi-refurb-dialog-' + SECTION_ID);
      if(!dlg) return;
      try{ dlg.showModal(); }catch(e){ dlg.setAttribute('open', ''); }
    }
    function closeRefurbDialog(){
      const dlg = document.getElementById('cmobi-refurb-dialog-' + SECTION_ID);
      if(dlg) dlg.close();
    }

    function handleBuyFallbackWhatsApp(productId){
      const data = getData();
      const product = data.find(m => m.id === productId);
      const productName = product ? product.name : '';
      const text = encodeURIComponent(
        'Hallo NAIPO-Team,\n\n' +
        (i18n.wa_unsicher || '') +
        (productName ? ' zum ' + productName : '') + '.\n\n' +
        'Danke!'
      );
      window.open('https://wa.me/494088369018?text=' + text, '_blank', 'noopener');
    }
    function handleBuyFallbackConsult(productId){
      cmobiTriggerNabe(productId ? [productId] : []);
    }
    function renderQuizIntro(){
      const body = document.getElementById('cmobi-quiz-body-' + SECTION_ID);
      if(!body) return;
      const q = i18n.quiz || {};
      body.innerHTML = `
        <div class="cmobi-quiz-intro">
          <div class="cmobi-quiz-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          </div>
          <p class="cmobi-quiz-lead">${q.intro || ''}</p>
          <button type="button" class="cmobi-btn cmobi-btn-primary cmobi-quiz-start">${q.start || "Los geht's"}</button>
        </div>
      `;
      body.querySelector('.cmobi-quiz-start')?.addEventListener('click', () => { quizStep = 0; renderQuizStep(); });
    }
    function renderQuizStep(){
      const body = document.getElementById('cmobi-quiz-body-' + SECTION_ID);
      if(!body) return;
      const q = i18n.quiz || {};
      const qid = 'q' + (quizStep + 1);
      const question = q[qid] || '';
      const opts = QUIZ_QUESTIONS[quizStep].options.map((opt, i) => {
        const label = q[qid + '_' + opt.key] || '';
        return `<button type="button" class="cmobi-quiz-opt" data-idx="${i}">${label}</button>`;
      }).join('');
      const stepLbl = (q.step || 'Frage {current} von {total}').replace('{current}', quizStep + 1).replace('{total}', QUIZ_QUESTIONS.length);
      const backBtn = quizStep > 0 ? `<button type="button" class="cmobi-btn ghost cmobi-quiz-back">${q.back || i18n.zurueck || ''}</button>` : '';
      const pct = ((quizStep) / QUIZ_QUESTIONS.length) * 100;
      body.innerHTML = `
        <div class="cmobi-quiz-progress"><div class="cmobi-quiz-progress-bar" style="width:${pct}%"></div></div>
        <div class="cmobi-quiz-step-label">${stepLbl}</div>
        <h4 class="cmobi-quiz-question">${question}</h4>
        <div class="cmobi-quiz-opts">${opts}</div>
        <div class="cmobi-quiz-nav">${backBtn}</div>
      `;
      body.querySelectorAll('.cmobi-quiz-opt').forEach(btn => {
        btn.addEventListener('click', () => {
          const optIdx = parseInt(btn.dataset.idx, 10);
          quizAnswers[quizStep] = optIdx;
          quizStep++;
          if(quizStep >= QUIZ_QUESTIONS.length){
            renderQuizResult();
          } else {
            renderQuizStep();
          }
        });
      });
      body.querySelector('.cmobi-quiz-back')?.addEventListener('click', () => {
        if(quizStep > 0){ quizStep--; renderQuizStep(); }
      });
    }
    function computeQuizResult(){
      const prefs = {};
      quizAnswers.forEach((optIdx, qIdx) => {
        const opt = QUIZ_QUESTIONS[qIdx].options[optIdx];
        Object.assign(prefs, opt.score);
      });
      const data = getData();
      const scored = data
        .filter(m => !m.is_benchmark && (!m.badges || m.badges.indexOf('discontinued') < 0))
        .map(m => {
          let score = 0;
          const price = parsePrice(m.price);
          if(prefs.budget && price !== null){
            const diff = Math.abs(prefs.budget - price);
            if(diff < 500) score += 30;
            else if(diff < 1500) score += 20;
            else if(diff < 3000) score += 10;
            if(price > prefs.budget * 1.3) score -= 20;
          }
          if(prefs.space === 'compact' && m.category === 'Compact') score += 25;
          if(prefs.space === 'medium' && (m.category === 'Base' || m.category === 'Pro')) score += 15;
          if(prefs.space === 'large' && (m.category === 'Pro Max' || m.category === 'Pro')) score += 20;
          if(prefs.tech === 'basic' && /2D(?!\s*Pro)/i.test(m.tech || '')) score += 15;
          if(prefs.tech === '3d' && /3D/i.test(m.tech || '')) score += 25;
          if(prefs.tech === '4d' && /4D/i.test(m.tech || '')) score += 30;
          if(prefs.use === 'wellness' && (m.badges || []).indexOf('bestseller') >= 0) score += 10;
          if(prefs.use === 'wellness' && istJa(m.aroma)) score += 10;
          if(prefs.use === 'therapy' && istJa(m.health_detection)) score += 15;
          if(prefs.use === 'therapy' && m.heating_areas && m.heating_areas.length > 2 && m.heating_areas !== '—') score += 10;
          if(prefs.use === 'b2b' && m.category === 'Business') score += 40;
          if(prefs.use !== 'b2b' && m.category === 'Business') score -= 30;
          if(prefs.height && m.height_range){
            if(prefs.height === 'tall' && /200|195/.test(m.height_range)) score += 10;
            if(prefs.height === 'small' && /150/.test(m.height_range)) score += 5;
          }
          if((m.badges || []).indexOf('flagship') >= 0) score += 5;
          return { m, score };
        })
        .sort((a, b) => b.score - a.score);
      const viable = scored.filter(x => x.score >= 0);
      const picks = viable.length >= 3 ? viable.slice(0, 3)
                   : viable.length >= 1 ? viable.slice(0, viable.length)
                   : scored.slice(0, 1);
      return picks.map(x => x.m);
    }
    function renderQuizResult(){
      const body = document.getElementById('cmobi-quiz-body-' + SECTION_ID);
      if(!body) return;
      const q = i18n.quiz || {};
      const top3 = computeQuizResult();
      const cards = top3.map((m, i) => `
        <div class="cmobi-quiz-card">
          <div class="cmobi-quiz-rank">#${i + 1}</div>
          ${m.image ? `<img class="cmobi-quiz-img" src="${escapeHtml(m.image)}" alt="${escapeHtml(m.name)}" loading="lazy">` : '<div class="cmobi-quiz-img-placeholder"></div>'}
          <div class="cmobi-quiz-card-body">
            <div class="cmobi-quiz-card-name">${escapeHtml(m.name)}</div>
            ${renderBadges(m.badges)}
            <div class="cmobi-quiz-card-meta">${escapeHtml(m.tech || '')} · ${escapeHtml(m.track || '')}</div>
            <div class="cmobi-quiz-card-price">${escapeHtml(cleanPriceString(m.price))}</div>
            <a class="cmobi-btn cmobi-btn-primary sm cmobi-buy-trigger" href="${escapeHtml(m.url)}" data-product-id="${escapeHtml(m.id)}">${escapeHtml(i18n.product_link || 'Produktseite')} ➔</a>
          </div>
        </div>
      `).join('');
      const compareLabel = (q.result_compare || 'Diese vergleichen').replace('3', top3.length);
      const compareBtn = top3.length >= 2
        ? `<button type="button" class="cmobi-btn cmobi-btn-primary cmobi-quiz-compare">${escapeHtml(compareLabel)}</button>`
        : '';
      body.innerHTML = `
        <div class="cmobi-quiz-result">
          <h4>${q.result_title || 'Deine Top-Empfehlungen'}</h4>
          <p class="cmobi-quiz-result-lead">${q.result_lead || ''}</p>
          <div class="cmobi-quiz-cards cmobi-quiz-cards--count-${top3.length}">${cards}</div>
          <div class="cmobi-quiz-result-actions">
            ${compareBtn}
            <button type="button" class="cmobi-btn ghost cmobi-quiz-restart">${q.result_restart || 'Quiz erneut starten'}</button>
          </div>
        </div>
      `;
      body.querySelector('.cmobi-quiz-compare')?.addEventListener('click', () => {
        selected.clear();
        top3.forEach(m => selected.add(m.id));
        saveToStorage();
        syncCheckboxes();
        updateBar();
        closeQuiz();
        setTimeout(() => {
          const openBtn = document.getElementById('cmobi-open-' + SECTION_ID);
          openCompare(openBtn);
        }, 150);
      });
      body.querySelector('.cmobi-quiz-restart')?.addEventListener('click', () => {
        quizAnswers = [];
        quizStep = 0;
        renderQuizIntro();
      });
    }

    function loadPdfLibs(){
      if(window.cmobiPdfLibs) return Promise.resolve(window.cmobiPdfLibs);
      if(window.cmobiPdfLoadPromise) return window.cmobiPdfLoadPromise;
      window.cmobiPdfLoadPromise = new Promise((resolve, reject) => {
        const s1 = document.createElement('script');
        s1.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
        s1.onerror = () => reject(new Error('jsPDF load failed'));
        s1.onload = () => {
          const s2 = document.createElement('script');
          s2.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
          s2.onerror = () => reject(new Error('html2canvas load failed'));
          s2.onload = () => {
            window.cmobiPdfLibs = {
              jsPDF: window.jspdf ? window.jspdf.jsPDF : window.jsPDF,
              html2canvas: window.html2canvas
            };
            resolve(window.cmobiPdfLibs);
          };
          document.head.appendChild(s2);
        };
        document.head.appendChild(s1);
      });
      return window.cmobiPdfLoadPromise;
    }
    async function exportComparePdf(){
      const target = document.getElementById('cmobi-compare-wrap-' + SECTION_ID);
      if(!target || !target.querySelector('.cmobi-compare-grid')){
        alert(i18n.min_alert || 'Bitte Produkte auswählen');
        return;
      }
      const btn = document.getElementById('cmobi-pdf-' + SECTION_ID);
      const origLabel = btn?.querySelector('span')?.textContent;
      if(btn){ btn.disabled = true; const s = btn.querySelector('span'); if(s) s.textContent = i18n.pdf_generating || 'PDF wird erstellt…'; }
      try{
        const { jsPDF, html2canvas } = await loadPdfLibs();
        const hadDark = ROOT.getAttribute('data-theme') === 'dark';
        if(hadDark) ROOT.setAttribute('data-theme', 'light');
        await new Promise(r => setTimeout(r, 100));
        const canvas = await html2canvas(target, { scale: 2, useCORS: true, backgroundColor: '#ffffff', logging: false });
        if(hadDark) ROOT.setAttribute('data-theme', 'dark');
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
        const pageW = pdf.internal.pageSize.getWidth();
        const pageH = pdf.internal.pageSize.getHeight();
        const imgW = pageW - 20;
        const imgH = (canvas.height * imgW) / canvas.width;
        pdf.setFontSize(16); pdf.setFont('helvetica', 'bold');
        pdf.text(i18n.pdf_title || 'NAIPO Massagesessel – Vergleich', 10, 12);
        pdf.setFontSize(9); pdf.setFont('helvetica', 'normal');
        const dt = new Date().toLocaleDateString(document.documentElement.lang || 'de-DE', {year:'numeric', month:'long', day:'numeric'});
        pdf.text((i18n.pdf_created || 'Erstellt am {date}').replace('{date}', dt) + '  ·  ' + location.hostname, 10, 17);
        let position = 22;
        let remainingH = imgH;
        let sOffY = 0;
        const printableH = pageH - position - 10;
        if(imgH <= printableH){
          pdf.addImage(imgData, 'PNG', 10, position, imgW, imgH);
        } else {
          const pageImgHPx = (printableH * canvas.width) / imgW;
          while(remainingH > 0){
            const sliceCanvas = document.createElement('canvas');
            sliceCanvas.width = canvas.width;
            sliceCanvas.height = Math.min(pageImgHPx, canvas.height - sOffY);
            const ctx = sliceCanvas.getContext('2d');
            ctx.drawImage(canvas, 0, sOffY, canvas.width, sliceCanvas.height, 0, 0, canvas.width, sliceCanvas.height);
            const sliceImg = sliceCanvas.toDataURL('image/png');
            const sliceH = (sliceCanvas.height * imgW) / canvas.width;
            pdf.addImage(sliceImg, 'PNG', 10, position, imgW, sliceH);
            sOffY += sliceCanvas.height;
            remainingH -= sliceH;
            if(remainingH > 0){
              pdf.addPage();
              position = 10;
            }
          }
        }
        pdf.setFontSize(8); pdf.setTextColor(120);
        pdf.text('Alsterwell GmbH · NAIPO · rhinoshopield.com · relax@rhinoshopield.com', 10, pageH - 5);
        pdf.save('naipo-vergleich-' + new Date().toISOString().slice(0,10) + '.pdf');
      }catch(err){
        console.error(err);
        alert(i18n.pdf_error || 'PDF-Erstellung fehlgeschlagen.');
      } finally {
        if(btn){ btn.disabled = false; const s = btn.querySelector('span'); if(s && origLabel) s.textContent = origLabel; }
      }
    }

    ROOT.addEventListener('change', function(e){
      const tgt = e.target;
      if(tgt.classList.contains('cmobi-chk')){
        toggleSelect(tgt.dataset.id);
        return;
      }
      if(tgt.id === 'cmobi-sort-' + SECTION_ID){
        refresh();
        return;
      }
      if(tgt.id === 'cmobi-diff-' + SECTION_ID){
        toggleDiffHighlight(tgt.checked);
        saveDiffState(tgt.checked);
        return;
      }
    });

    const searchInput = document.getElementById('cmobi-q-' + SECTION_ID);
    if(searchInput){
      searchInput.addEventListener('input', debounce(refresh, 200));
    }

    ROOT.addEventListener('click', function(e){
      const tgt = e.target;

      const buyTrigger = tgt.closest('.cmobi-buy-trigger');
      if(buyTrigger){
        e.preventDefault();
        openBuyDialog(buyTrigger.dataset.productId, buyTrigger);
        return;
      }
      const buyWa = tgt.closest('#cmobi-buy-fallback-wa-' + SECTION_ID);
      if(buyWa){
        e.preventDefault();
        handleBuyFallbackWhatsApp(buyWa.dataset.productId);
        return;
      }
      const buyConsult = tgt.closest('#cmobi-buy-fallback-consult-' + SECTION_ID);
      if(buyConsult){
        e.preventDefault();
        handleBuyFallbackConsult(buyConsult.dataset.productId);
        return;
      }
      if(tgt.closest('#cmobi-buy-close-' + SECTION_ID)){
        closeBuyDialog();
        return;
      }

      const refurbTrigger = tgt.closest('.cmobi-refurb-trigger');
      if(refurbTrigger){
        e.preventDefault();
        openRefurbDialog(refurbTrigger);
        return;
      }
      if(tgt.closest('#cmobi-refurb-close-' + SECTION_ID)){
        closeRefurbDialog();
        return;
      }

      if(tgt.classList.contains('cmobi-tag-x')){
        const tag = tgt.closest('.cmobi-tag');
        if(tag){
          selected.delete(tag.dataset.id);
          saveToStorage();
          syncCheckboxes();
          updateBar();
        }
        return;
      }
      if(tgt.closest('#cmobi-clear-' + SECTION_ID)){
        selected.clear();
        saveToStorage();
        syncCheckboxes();
        updateBar();
        return;
      }
      const openBtn = tgt.closest('#cmobi-open-' + SECTION_ID);
      if(openBtn){ openCompare(openBtn); return; }
      if(tgt.closest('#cmobi-close-' + SECTION_ID)){ closeCompare(); return; }
      if(tgt.closest('#cmobi-reset-filters-' + SECTION_ID)){
        const q = document.getElementById('cmobi-q-' + SECTION_ID);
        if(q) q.value = '';
        CHIP_STATE.category = '';
        CHIP_STATE.price = '';
        CHIP_STATE.feats.clear();
        ROOT.querySelectorAll('.cmobi-chip').forEach(c => c.classList.remove('cmobi-chip--active'));
        ROOT.querySelectorAll('.cmobi-chip[data-value=""]').forEach(c => c.classList.add('cmobi-chip--active'));
        refresh();
        return;
      }
      if(tgt.closest('#cmobi-share-' + SECTION_ID)){ shareNative(); return; }
      if(tgt.closest('#cmobi-wa-modal-' + SECTION_ID)){ shareWhatsApp(); return; }
      if(tgt.closest('#cmobi-wa-' + SECTION_ID)){ shareWhatsApp(); return; }
      const antwortBtn = tgt.closest('.cmobi-antwort-btn');
      if(antwortBtn){ antwortSenden(antwortBtn.getAttribute('data-antwort')); return; }
      if(tgt.closest('#cmobi-share-modal-' + SECTION_ID)){ copyShareLink(); return; }

      const consultModal = tgt.closest('#cmobi-consult-modal-' + SECTION_ID);
      if(consultModal){
        cmobiTriggerNabe([...selected]);
        return;
      }

      if(tgt.closest('#cmobi-theme-' + SECTION_ID)){ toggleTheme(); return; }

      if(tgt.closest('#cmobi-pdf-' + SECTION_ID)){ exportComparePdf(); return; }

      const quizBtn = tgt.closest('#cmobi-quiz-btn-' + SECTION_ID);
      if(quizBtn){ openQuiz(quizBtn); return; }
      if(tgt.closest('#cmobi-quiz-close-' + SECTION_ID)){ closeQuiz(); return; }

      const chip = tgt.closest('.cmobi-chip');
      if(chip){
        toggleChip(chip.dataset.filter, chip.dataset.value, chip);
        return;
      }

      const favBtn = tgt.closest('.cmobi-fav-btn');
      if(favBtn){
        e.preventDefault();
        toggleFavorite(favBtn.dataset.id);
        return;
      }

      const beratungLink = tgt.closest('a[href="#beratung"]');
      if(beratungLink){
        e.preventDefault();
        const row = beratungLink.closest('[data-id]') || beratungLink.closest('tr, article');
        let productIds = [];
        if(row && row.dataset.id){
          productIds = [row.dataset.id];
        } else {
          const parent = beratungLink.closest('tr, article');
          const chk = parent?.querySelector('.cmobi-chk');
          if(chk) productIds = [chk.dataset.id];
        }
        cmobiTriggerNabe(productIds);
        return;
      }
    });

    const dialog = document.getElementById('cmobi-dialog-' + SECTION_ID);
    if(dialog){
      dialog.addEventListener('click', function(e){
        if(e.target === dialog) closeCompare();
      });
      dialog.addEventListener('close', function(){
        if(lastFocusBeforeDialog && typeof lastFocusBeforeDialog.focus === 'function'){
          try{ lastFocusBeforeDialog.focus(); }catch(e){}
        }
      });
    }

    const quizDialog = document.getElementById('cmobi-quiz-dialog-' + SECTION_ID);
    if(quizDialog){
      quizDialog.addEventListener('click', function(e){
        if(e.target === quizDialog) closeQuiz();
      });
      quizDialog.addEventListener('close', function(){
        if(lastFocusBeforeDialog && typeof lastFocusBeforeDialog.focus === 'function'){
          try{ lastFocusBeforeDialog.focus(); }catch(e){}
        }
      });
    }

    const buyDialog = document.getElementById('cmobi-buy-dialog-' + SECTION_ID);
    if(buyDialog){
      buyDialog.addEventListener('click', function(e){
        if(e.target === buyDialog) closeBuyDialog();
      });
      buyDialog.addEventListener('close', function(){
        if(lastFocusBeforeDialog && typeof lastFocusBeforeDialog.focus === 'function'){
          try{ lastFocusBeforeDialog.focus(); }catch(e){}
        }
      });
    }

    const refurbDialog = document.getElementById('cmobi-refurb-dialog-' + SECTION_ID);
    if(refurbDialog){
      refurbDialog.addEventListener('click', function(e){
        if(e.target === refurbDialog) closeRefurbDialog();
      });
      refurbDialog.addEventListener('close', function(){
        if(lastFocusBeforeDialog && typeof lastFocusBeforeDialog.focus === 'function'){
          try{ lastFocusBeforeDialog.focus(); }catch(e){}
        }
      });
    }

    if(window.matchMedia){
      try{
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
          if(!ROOT.getAttribute('data-theme')) updateThemeIcon();
        });
      }catch(e){}
    }

    initTheme();
    loadFavorites();
    if(!loadFromHash()){
      loadFromStorage();
    }
    refresh();
    zeigeAntwortLeiste();
    injectJsonLd();
  }

  function initNabe(sectionId){
    var root = document.querySelector('.nabe[data-nabe-id="' + sectionId + '"]');
    if(!root) return;

    var trigger = document.getElementById('nabe-mini-trigger-' + sectionId);
    var sheet = document.getElementById('nabe-sheet-' + sectionId);
    var backdrop = document.getElementById('nabe-sheet-backdrop-' + sectionId);
    var closeBtn = document.getElementById('nabe-sheet-close-' + sectionId);
    var closeBtnX = document.getElementById('nabe-sheet-close-x-' + sectionId);
    var scrollY = 0;

    if(sheet && sheet.parentElement !== document.body){
      document.body.appendChild(sheet);
    }
    if(backdrop && backdrop.parentElement !== document.body){
      document.body.appendChild(backdrop);
    }

    function openSheet(){
      if(!sheet || !backdrop) return;
      scrollY = window.scrollY;
      backdrop.hidden = false;
      sheet.hidden = false;
      void backdrop.offsetWidth;
      backdrop.classList.add('is-open');
      sheet.classList.add('is-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
    function closeSheet(){
      if(!sheet || !backdrop) return;
      backdrop.classList.remove('is-open');
      sheet.classList.remove('is-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      window.scrollTo(0, scrollY);
      setTimeout(function(){
        backdrop.hidden = true;
        sheet.hidden = true;
      }, 300);
    }

    if(trigger) trigger.addEventListener('click', openSheet);
    if(closeBtn) closeBtn.addEventListener('click', closeSheet);
    if(closeBtnX) closeBtnX.addEventListener('click', closeSheet);
    if(backdrop) backdrop.addEventListener('click', closeSheet);

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && sheet && sheet.classList.contains('is-open')){
        closeSheet();
      }
    });

    function tryOpenChat(){
      try{
        if(window.Chatty && typeof window.Chatty.open === 'function'){ window.Chatty.open(); return true; }
        if(window.$chatty && typeof window.$chatty.open === 'function'){ window.$chatty.open(); return true; }
        if(window.chatty && typeof window.chatty.open === 'function'){ window.chatty.open(); return true; }
        if(window.tidioChatApi && typeof window.tidioChatApi.open === 'function'){ window.tidioChatApi.open(); return true; }
        if(window.$crisp && typeof window.$crisp.push === 'function'){ window.$crisp.push(['do', 'chat:open']); return true; }
        if(window.Intercom && typeof window.Intercom === 'function'){ window.Intercom('show'); return true; }
        var sels = ['#chatty-home','[class*="chatty-launcher" i]','[class*="chatty-button" i]','[data-chatty-launcher]'];
        for(var i = 0; i < sels.length; i++){
          var el = document.querySelector(sels[i]);
          if(el){ el.click(); return true; }
        }
        window.location.hash = '#chatty-home';
        return true;
      }catch(e){}
      return false;
    }

    function tryOpenCowlendar(url){
      try{
        if(window.Cowlendar && typeof window.Cowlendar.open === 'function'){ window.Cowlendar.open(); return true; }
        var u = new URL(url, window.location.origin);
        var sid = u.searchParams.get('cow_sid');
        var vid = u.searchParams.get('cow_vid');
        if(sid && vid){
          var current = new URL(window.location.href);
          current.searchParams.set('cow_sid', sid);
          current.searchParams.set('cow_vid', vid);
          window.location.href = current.toString();
          return true;
        }
      }catch(e){}
      return false;
    }

    document.querySelectorAll('[data-nabe-chat]').forEach(function(el){
      var sheetMatch = el.closest('#nabe-sheet-' + sectionId);
      var rootMatch = el.closest('.nabe[data-nabe-id="' + sectionId + '"]');
      if(!sheetMatch && !rootMatch) return;
      el.addEventListener('click', function(e){
        e.preventDefault();
        tryOpenChat();
        if(sheet && sheet.classList.contains('is-open')){
          setTimeout(closeSheet, 100);
        }
      });
    });

    document.querySelectorAll('[data-channel="phone"]').forEach(function(el){
      var sheetMatch = el.closest('#nabe-sheet-' + sectionId);
      var rootMatch = el.closest('.nabe[data-nabe-id="' + sectionId + '"]');
      if(!sheetMatch && !rootMatch) return;
      el.addEventListener('click', function(e){
        var href = el.getAttribute('href');
        if(href && href.indexOf('cow_sid=') !== -1){
          e.preventDefault();
          tryOpenCowlendar(href);
          if(sheet && sheet.classList.contains('is-open')){
            setTimeout(closeSheet, 100);
          }
        }
      });
    });
  }

  function startSection(sectionId){
    try{ initCmobi(sectionId); }catch(e){ if(window.console) console.error("[nc-vergleichstool] initCmobi", e); }
    try{ initNabe(sectionId); }catch(e){ if(window.console) console.error("[nc-vergleichstool] initNabe", e); }
  }

  function gate(sectionId){
    var root = document.getElementById('cmobi-' + sectionId);
    var immediate = !root
      || (window.Shopify && window.Shopify.designMode)
      || !('IntersectionObserver' in window)
      || (window.location.hash || '').indexOf('compare=') !== -1; /* geteilter Deep-Link */
    if(immediate){ startSection(sectionId); return; }
    var io = new IntersectionObserver(function(entries, obs){
      for(var i = 0; i < entries.length; i++){
        if(entries[i].isIntersecting){
          obs.disconnect();
          startSection(sectionId);
          return;
        }
      }
    }, { rootMargin: '300px 0px 300px 0px' });
    io.observe(root);
  }

  window.__ncVglBoot = function(){
    var q = window.__ncVglQueue = window.__ncVglQueue || [];
    while(q.length){ gate(q.shift()); }
  };
  window.__ncVglBoot();
})();
